import { Text, Spinner, Flex } from '@volue/wave-react';
import React from 'react';

export const CenteredLoadingPage: React.FunctionComponent<{
  text: string | JSX.Element;
}> = props => (
  <Flex gap="spacingS" className="pAl jcC h100 w100">
    <Text className="beta" css={{ color: '$colorAccent70' }}>
      {props.text}
    </Text>
    <Spinner size="large" inline />
  </Flex>
);
